/* ===========
 * Use default token
 * This Hack is useful cuz' the backend can't support free browsing at the page
 */

const defaultTokenPeru = '6248d85a9d5b6a13bfbde69b2bcb81db';
const defaultTokenChile = '6248d85a9d5b61234fbde69b2bcb81d7';
/*
if (process.env.NODE_ENV === 'production') {
  defaultToken = '6248d85a9d5b6a13bfbde69b2bcb81db';
} else {
  defaultToken = 'e702aff567bc8724c348d4a3b4504a4e';
}*/

/* ==========
 * To check if the current user is a country's default user or notifications
 */
export const isNotDefault = () => {
  const t = localStorage.getItem('id_token');
  if (t === null || t === defaultTokenPeru || t === defaultTokenChile) {
    return false;
  }
  return true;
};

export const setDefault = () => {
  if (localStorage.getItem('id_token') === null && window.location.hostname.search('.cl') !== -1) {
    /* First time in Chile */
    localStorage.setItem('id_token', defaultTokenChile);
    localStorage.setItem('codigoPais', 'CL');
    localStorage.setItem('media', 'https://www.mesa247.cl/');
  } else if (localStorage.getItem('id_token') === null) {
    /* First time anywhere */
    localStorage.setItem('id_token', defaultTokenPeru);
    localStorage.setItem('codigoPais', 'PE');
    localStorage.setItem('media', 'https://www.mesa247.pe/');
  }
  localStorage.setItem('storage', 'https://img.mesa247.pe/');
};

export default {
  isNotDefault,
  setDefault,
};



// WEBPACK FOOTER //
// ./src/app/services/utils/defaultSession.js